import { render, staticRenderFns } from "./standardCard-edit.vue?vue&type=template&id=a788661e"
import script from "./standardCard-edit.vue?vue&type=script&lang=js"
export * from "./standardCard-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a788661e')) {
      api.createRecord('a788661e', component.options)
    } else {
      api.reload('a788661e', component.options)
    }
    module.hot.accept("./standardCard-edit.vue?vue&type=template&id=a788661e", function () {
      api.rerender('a788661e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/product-management/standardCard-management/standardCard-edit.vue"
export default component.exports